"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImplementationCommitment = void 0;
const common_1 = require("../../common");
const sales_order_release_model_1 = require("./../../sales-order/models/sales-order-release.model");
class ProductImplementationCommitment extends common_1.MongoSubDocument {
}
exports.ProductImplementationCommitment = ProductImplementationCommitment;
//# sourceMappingURL=product-implementation-commitment.model.js.map